import React from 'react';
import {KnowledgeSkillsAndAbilitiesSelect} from './KnowledgeSkillsAndAbilitiesSelect';
import {RESOURCE_FIELD_TOOLTIPS} from '../../../utils/tooltipConstants';

export const KnowledgeSkillsAndAbilitiesWithInfoSelect = () => {
  return <KnowledgeSkillsAndAbilitiesSelect infoText={RESOURCE_FIELD_TOOLTIPS.ksas} />;
};
